module.exports = __webpack_public_path__ + "img/banner_livestream.3b9a60a3.png";